import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

function VarianceAnalysisChart({ data = [] }) {
    const { t } = useTranslation();

    const chartData = {
        labels: data.map(item => item.code),
        datasets: [
            {
                label: t("costTracking.variance-percentage"),
                data: data.map(item => item.variancePercentage),
                backgroundColor: data.map(item => 
                    item.variancePercentage > 0 
                        ? 'rgba(255, 99, 132, 0.8)' // Over budget - red
                        : 'rgba(75, 192, 192, 0.8)' // Under budget - green
                ),
                borderColor: data.map(item => 
                    item.variancePercentage > 0 
                        ? 'rgba(255, 99, 132, 1)'
                        : 'rgba(75, 192, 192, 1)'
                ),
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: t("costTracking.variance-analysis"),
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        return `${context.parsed.y.toFixed(1)}%`;
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function(value) {
                        return value + '%';
                    }
                }
            },
        },
    };

    if (data.length === 0) {
        return (
            <Card>
                <Card.Header>
                    <h6 className="mb-0">{t("costTracking.variance-analysis")}</h6>
                </Card.Header>
                <Card.Body className="text-center py-5">
                    <p className="text-muted">{t("costTracking.no-significant-variances")}</p>
                </Card.Body>
            </Card>
        );
    }

    return (
        <Card>
            <Card.Header>
                <h6 className="mb-0">{t("costTracking.variance-analysis")}</h6>
            </Card.Header>
            <Card.Body>
                <Bar data={chartData} options={options} />
            </Card.Body>
        </Card>
    );
}

export default VarianceAnalysisChart;